import { render } from "./HandwritingToText.vue?vue&type=template&id=e5e75916&scoped=true"
import script from "./HandwritingToText.vue?vue&type=script&lang=js"
export * from "./HandwritingToText.vue?vue&type=script&lang=js"

import "./HandwritingToText.vue?vue&type=style&index=0&id=e5e75916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e75916"]])

export default __exports__